import { render, staticRenderFns } from "./duanManage.vue?vue&type=template&id=3fa97d00&"
import script from "./duanManage.vue?vue&type=script&lang=js&"
export * from "./duanManage.vue?vue&type=script&lang=js&"
import style0 from "./duanManage.vue?vue&type=style&index=0&id=3fa97d00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports